import { render, staticRenderFns } from "./dental.vue?vue&type=template&id=eb191f12&"
import script from "./dental.vue?vue&type=script&lang=js&"
export * from "./dental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports